const DOMAIN = window.location.origin;

export const API_ENDPOINTS = {
  DOMAIN,
  CLIENT_BILL: `${DOMAIN}/client/bills/`,
  CLIENT_BILL_ID_LIST: `${DOMAIN}/client/bill/billidlist/`,
  CLIENT_BILL_DOWNLOAD: (billId: string) =>`${DOMAIN}/client/bill/${billId}/download/`,
  CLIENT_BILL_DOWNLOADLIST: `${DOMAIN}/client/bill/downloadlist/`,
  CLIENT_CALLCENTER_MANAGEMENT: `${DOMAIN}/client/callcentermanagement/`,
  CLIENT_CIFS_CUPS: `${DOMAIN}/client/cifs/cups/`,
  CLIENT_CONSUMPTION_DOWNLOAD: `${DOMAIN}/client/consumption/download/`,
  CLIENT_CUPS: `${DOMAIN}/client/cups/cuplist/`,
  CLIENT_CUPS_DETAIL: `${DOMAIN}/client/cups/detail/`,
  CLIENT_CUPS_CONTACT_DATA: `${DOMAIN}/client/cups/contactdata/`,
  CLIENT_CUPS_DOCUMENT: `${DOMAIN}/client/cups/document/`,
  CLIENT_CUPS_GETCOMMUNICATION: `${DOMAIN}/client/cups/getcommunication/`,
  CLIENT_CUPS_SETCOMMUNICATION: `${DOMAIN}/client/cups/setcommunication/`,
  CLIENT_CUPS_SHIPPING_ADDRESS: `${DOMAIN}/client/cups/shippingaddress/`,
  CLIENT_DOCUMENT: `${DOMAIN}/client/document/`,
  CLIENT_MANAGEMENT: `${DOMAIN}/client/management/history/`,
  CLIENT_MANAGEMENT_ID_DOCUMENTS: (idCallCenter: string) => `${DOMAIN}/client/management/${idCallCenter}/documents/`,
  CLIENT_MANAGEMENT_DETAIL: `${DOMAIN}/client/management/detail/`,
  CLIENT_MANAGEMENT_DOCUMENT: `${DOMAIN}/client/management/document/`,
  CLIENT_SUMMARY_BILL: `${DOMAIN}/client/summary/bill/`,
  /* CLIENT_SUMMARY_CONSUMPTION: `${DOMAIN}/client/summary/consumption`, */
  CLIENT_SUMMARY_CONSUMPTION: `${DOMAIN}/client/summary/consumptionperiod/`,
  CLIENT_SUMMARY_CONSUMPTION_COMPARATIVE: `${DOMAIN}/client/summary/consumption/comparative/`,
  LOCATIONS: `${DOMAIN}/locations/`,
  USER_LOGIN: `${DOMAIN}/user/login/`,
  USER_OWNERDATA: `${DOMAIN}/user/ownerdata/`,
  USER_RESET_PASSWORD: `${DOMAIN}/user/resetpassword/`,
  USER_PASSWORD: `${DOMAIN}/user/password/`,
  USER_CHECK: `${DOMAIN}/user/check/`,
  LOCATIONS_CITIES: `${DOMAIN}/locations/cities/`,
  LOCATIONS_MUNICIPALITIES: `${DOMAIN}/locations/municipalities/`,
  LOCATIONS_PROVINCES: `${DOMAIN}/locations/provinces/`,
};
